// extracted by mini-css-extract-plugin
module.exports = {"Container":"BlockDistance_Container__Dxp_p","BlockDistance":"BlockDistance_BlockDistance__m4M5h","Red":"BlockDistance_Red__K3c0G","hideIcon":"BlockDistance_hideIcon__g9pXk"};